/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumWorkStatus = {
	...getStatus(),
	...enumMixn
}
export default EnumWorkStatus
function getStatus() {
    let obj = {}
    let status = [{
        'code': 0,
        'info': '空闲'
        },
        {
        'code': 1,
        'info': '水样测试'
        },
        {
        'code': 2,
        'info': '标样核查'
        },
        {
        'code': 3,
        'info': '零点核查'
        },
        {
        'code': 4,
        'info': '跨度核查'
        },
        {
        'code': 5,
        'info': '空白测试'
        },
        {
        'code': 6,
        'info': '平行样测试'
        },
        {
        'code': 7,
        'info': '加标回收'
        },
        {
        'code': 8,
        'info': '空白校准'
        },
        {
        'code': 9,
        'info': '标样校准'
        },
        {
        'code': 10,
        'info': '初始化(清洗)'
        },
        {
        'code': 11,
        'info': '停止测试'
        },
        {
        'code': 19,
        'info': '标定'
        },
        {
        'code': 28,
        'info': '标样1测量'
        },
        {
        'code': 29,
        'info': '标样2测量'
        },
        {
        'code': 30,
        'info': '故障'
        },
        {
        'code': 31,
        'info': '异常处理'
        },
        {
        'code': 32,
        'info': '初始化装液'
        },
        {
        'code': 33,
        'info': '其他'
        },
        {
        'code': 41,
        'info': '受控'
        },
        {
        'code': 42,
        'info': '连续'
        },
        {
        'code': 43,
        'info': '周期'
        },
        {
        'code': 44,
        'info': '定点'
        }]
        status.forEach(i=> {
            obj[i.info] = new EnumItem(i.info, i.code)
        })
        return obj
}